/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PharmacyViewModel } from './PharmacyViewModel'; 

export function getPharmacyOptions(id: string, onSuccess?: (result: PharmacyViewModel) => void) {
	return queryOptions({
		queryKey: ['pharmacy', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/pharmacies/queries/getpharmacy/' + id;
			const resp = await axios.get<PharmacyViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}